<div class="step-navigation-wrapper no-print" *ngIf="navigationSteps.length > 0">
  <div class="grid-x grid-margin-x">
    <div class="cell small-12 large-offset-2 large-8" [class.extra-element]="navigationPostElement || navigationPreElement">
      <nav app-step-navigation-extra *ngIf="navigationPreElement" [navigationElement]="navigationPreElement" [class]="elementClass + ' extra left'"></nav>
      <nav [class]="elementClass">
        <div *ngFor="let step of navigationSteps; last as isLast" [class]="step.class">
          <a [routerLink]="step.class && step.class?.indexOf('active') > -1? step.path : null"><span [innerHTML]="getPathTextkey(step.path) | translate"></span></a>
          <div class="children" *ngIf="step.children.length > 0">
            <span class="active-status overall hide-for-medium" [style.width]="getActiveWidthOverall(step.children)"></span>
            <span class="child-section show-for-medium">
              <span class="active-status" [style.width]="getSectionStartsteps(step.children).length > 0 && getSectionStartsteps(step.children)[0].class.indexOf('active') > -1? '100%' : '0%'"></span>
            </span>
            <span class="child-section show-for-medium" *ngFor="let child of getSectionStartsteps(step.children)">
              <a *ngIf="!isAdvisorEnd" [title]="getPathTextkey(child.path) | translate" [class]="child.class" [routerLink]="child.class && child.class?.indexOf('active') > -1? child.path : null"></a>
              <span *ngIf="!isAdvisorEnd" class="active-status" [style.width]="getActiveWidthChild(child, step.children)"></span>
            </span>
          </div>
        </div>
      </nav>
      <nav app-step-navigation-extra *ngIf="navigationPostElement" [navigationElement]="navigationPostElement" [class]="elementClass + ' extra right'"></nav>
    </div>
  </div>
</div>
